import React from 'react';

export default function ChatSaveErrorBanner({ message }: { message: string | null | undefined }) {
  if (!message) return null;
  return (
    <p style={{ color: '#b83d4c', fontSize: 12, padding: '8px 16px 0', margin: 0 }} role="alert">
      {message}
    </p>
  );
}
